module.exports = __webpack_public_path__ + "assets/img/collection2.41239c2e.svg";